<template>
    <div class="target-expand" :class="{'expand-disabled': disabled}">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'LdFullscreenExpansion',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        if (!this.disabled) {
            this.$nextTick(() => {
                const expandButton = this.$el.querySelector('.button-toggle-expand');

                if (!expandButton) {
                    throw Error("LdFullscreenToggleExpandButton is required in LdFullscreenExpansion");
                }
            });
        }
    }
}
</script>
